/**
 * @owner @Appboy/clip
 */

export const contentCardsConsumption =
  "/analytics_dashboard/:app_group_id/content_cards_credit_consumption_detail_data";
